<template>
  <v-layout justify-center fill-height align-center>
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-layout>
</template>

<script>
export default {
  name: 'PaymentStatusTrigger',

  computed: {
    status () {
      return this.$route.params.status
    },
  },

  created () {
    window.parent.postMessage({ status: this.status })
  },
}
</script>

<style></style>
